import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BatterAttributesTable from '../components/BatterAttributesTable';
import { API_ENDPOINTS } from '../config/api';

const BatterAttributesPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Batter Attributes
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Detailed batting attributes including hitting vs LHP/RHP, speed, and fielding metrics.
        </Typography>
        <BatterAttributesTable apiUrl={API_ENDPOINTS.BATTER_ATTRIBUTES_PAGINATED} />
      </Box>
    </Container>
  );
};

export default BatterAttributesPage;
